import Glide from "@glidejs/glide";

window.Testimonials = {
    init() {
        this.initGlide();
    },

    initGlide() {
        const testimonialGlide = new Glide('.testimonial-glide');
        testimonialGlide.mount();
    }
};
